import { FC, useState } from 'react';
import AgentChatInput from '../AgentChatInput/AgentChatInput';
import AgentChatWindowHeader from '../AgentChatWindowHeader/AgentChatWindowHeader';
import AgentChatMessageList from '../AgentChatMessageList/AgentChatMessageList';
import AgentChatEmptyState from '../AgentChatEmptyState/AgentChatEmptyState';
import { NudosStaticAlertInComponent } from '../../../../../../../components/NudosComponents';
import { AGENT_CHAT_FILTER_OPTIONS, IAgentResponseData } from '../../../../../../../types/agentChat.types';
import { postAgentChat } from '../../../../../../../services/agentChat.service';
import './AgentChatWindow.scss';

/**
 * Componente para la sección de ventana de chat de Bordi
 * Incluye los mensajes y el input para enviar nuevos mensajes
 */
const AgentChatWindow: FC<IAgentChatWindowProps> = ({
  question,
  handleSetQuestion,
  selectedHistoryResponse,
  refreshHistory
}) => {
  const [error, setError] = useState<boolean>(false);
  const [loadingSendMessage, setLoadingSendMessage] = useState<boolean>(false);
  const [agentResponse, setAgentResponse] = useState<IAgentResponseData>();

  const currentResponse = selectedHistoryResponse || agentResponse;

  const handleSendMessage = async (question: string, option: AGENT_CHAT_FILTER_OPTIONS) => {
    handleSetQuestion(question);
    setAgentResponse(undefined);
    setError(false);
    try {
      setLoadingSendMessage(true);
      const agentResponse = await postAgentChat({ question, option });
      if (agentResponse) {
        setAgentResponse(agentResponse.data);
        refreshHistory();
      }
    } catch (error) {
      setError(true);
    } finally {
      setLoadingSendMessage(false);
    }
  };

  return (
    <div className="agentChatWindow">
      {question && <AgentChatWindowHeader />}

      {question && (
        <AgentChatMessageList
          question={question}
          isLoading={loadingSendMessage}
          error={error}
          handleSetQuestion={handleSetQuestion}
          agentResponse={currentResponse}
          isHistoryResponse={!!selectedHistoryResponse}
          refreshHistory={refreshHistory}
        />
      )}

      {!question && <AgentChatEmptyState handleSendMessage={handleSendMessage} />}

      <AgentChatInput handleSendMessage={handleSendMessage} isDisabled={!!question} />

      <NudosStaticAlertInComponent
        type="information"
        alertOptions={{
          title:
            'Las respuestas son generadas con inteligencia artificial y pueden tener errores. Estamos mejorándolo constantemente.'
        }}
        customClassname="agentChatWindowAlert"
      />
    </div>
  );
};

interface IAgentChatWindowProps {
  question?: string;
  handleSetQuestion: (question?: string) => void;
  selectedHistoryResponse?: IAgentResponseData;
  refreshHistory: () => Promise<void>;
}

export default AgentChatWindow;
